module.exports = __webpack_public_path__ + "img/onboarding_project_arrow.3830bbce.svg";